import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_URL}/api/Message`
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
let logoutPage = ''
instance.interceptors.request.use(reqConfig => {
  if (Vue.prototype.$getCookie('comLoginToken')) {
    const xCorrelationId = Vue.prototype.$getGuid()
    reqConfig.headers = {
      KingnetAuth: 'Cookies ' + Vue.prototype.$getCookie('comLoginToken').split('token=').pop(),
      'X-Correlation-Id': xCorrelationId
    }
    Sentry.setTag('X-Correlation-Id', xCorrelationId)
    return reqConfig
  } else {
    // eslint-disable-next-line eqeqeq
    if (logoutPage != router.history.current.name) {
      logoutPage = router.history.current.name
      Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        router.push({ name: 'LoginMain' })
      })
    } else {
      logoutPage = ''
    }
  }
}, err => {
  return Promise.reject(err)
})
instance.interceptors.response.use(
  res => res,
  err => {
    if (err && err.response && (err.response.status === 400 || err.response.status === 401 || err.response.status === 403 || err.response.status === 404)) {
      // eslint-disable-next-line eqeqeq
      if (logoutPage != router.history.current.name && err.response.data.Message || err.response.data.ErrorMessage.Description && err.config.url.substr(-4) !== 'Type') {
        logoutPage = router.history.current.name
        Vue.prototype.$alert(`${err.response.data.Message || err.response.data.ErrorMessage.Description}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          const isUserUnactivated = err.response.data.ErrorMessage.Description.includes('已解除開通')
          if (err.response.status === 400 || err.response.status === 401 || (err.response.status === 404 && !isUserUnactivated)) { router.push({ name: 'LoginMain' }) } else if (err.response.status === 403) { Vue.prototype.$toMainPage() }
        })
      } else {
        logoutPage = ''
      }
    }
    return Promise.reject(err)
  }
)

// Swagger: https://local.kingnetsmart.com.tw/core/index.html#/Message
export const apiMessage = {
  // 列表頁
  List: {
    GetMessageList: (requestData, config) => instance.get('/List', Object.assign({}, { params: requestData }, config)), // 取得意見反映列表
    GetMessageType: (config) => instance.get('/Type', config),
    GetMessageTotal: (requestData, config) => instance.get('/Total', Object.assign({}, { params: requestData }, config)), // 取得搜尋總筆數
    GetMessageExport: (requestData, config) => instance.get('/Export', Object.assign({}, { params: requestData }, config)) // 取得匯出檔案
  },
  // 回覆頁
  Reply: {
    GetMessageDetail: (requestData, config) => instance.get('/Detail', Object.assign({}, { params: requestData }, config)), // 取得回覆頁內容
    GetMessageFileLimited: (config) => instance.get('/FileLimited', { config }), // 取得回覆檔案數量限制
    PostMessageUploadReplyFile: (requestData, config) => instance.post('/UploadReplyFile', requestData, config), // 檔案換url
    PostMessageReply: (requestData, config) => instance.post('/Reply', requestData, config) // post回覆內容
  }
}
